// @ts-nocheck
import React from 'react'
import {NavLink} from 'react-router-dom'
import {AFF} from './affiliateTheme'
import IncomingCallPopup from './IncomingCallPopup'

const TABS = [
  {to: '/affiliate/dashboard', label: 'סקירה', icon: 'bi-grid-1x2'},
  {to: '/affiliate/leads-manager', label: 'סוכנים ולידים', icon: 'bi-person-rolodex'},
  {to: '/affiliate/add-customer', label: 'הוספת לקוח', icon: 'bi-person-plus'},
  {to: '/affiliate/client-register', label: 'הרשמת לקוח', icon: 'bi-link-45deg'},
  {to: '/affiliate/agent-import', label: 'ייבוא לפי סוכן (AI)', icon: 'bi-robot'},
  {to: '/affiliate/meetings', label: 'פגישות', icon: 'bi-calendar-check'},
  {to: '/affiliate/whatsapp', label: 'וואטסאפ', icon: 'bi-whatsapp'},
  {to: '/affiliate/payouts', label: 'תשלומים', icon: 'bi-cash-coin'},
]

// Consistent header + tab bar wrapping every affiliate page, for a cohesive portal feel.
const AffiliateShell = ({title, subtitle, children, action}) => {
  return (
    <div dir='rtl' style={{direction: 'rtl'}}>
      <IncomingCallPopup />
      {/* Hero header */}
      <div
        style={{
          background: AFF.accentGrad,
          borderRadius: AFF.radius,
          padding: '28px 32px',
          color: '#fff',
          marginBottom: 20,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: 16,
        }}
      >
        <div>
          <div style={{fontSize: 13, opacity: 0.85, fontWeight: 600, letterSpacing: 0.5}}>
            תוכנית השותפים · fbzipper
          </div>
          <h1 style={{color: '#fff', margin: '4px 0 0', fontSize: 26, fontWeight: 700}}>{title}</h1>
          {subtitle && <div style={{opacity: 0.9, marginTop: 6, fontSize: 14}}>{subtitle}</div>}
        </div>
        {action && <div>{action}</div>}
      </div>

      {/* Tab nav */}
      <div
        style={{
          display: 'flex',
          gap: 6,
          flexWrap: 'wrap',
          marginBottom: 20,
          background: '#fff',
          padding: 8,
          borderRadius: 14,
          boxShadow: AFF.cardShadow,
          border: `1px solid ${AFF.border}`,
        }}
      >
        {TABS.map((t) => (
          <NavLink
            key={t.to}
            to={t.to}
            style={({isActive}) => ({
              display: 'flex',
              alignItems: 'center',
              gap: 8,
              padding: '9px 16px',
              borderRadius: 10,
              fontWeight: 600,
              fontSize: 14,
              textDecoration: 'none',
              transition: 'all .15s',
              color: isActive ? '#fff' : AFF.ink,
              background: isActive ? AFF.accent : 'transparent',
            })}
          >
            <i className={`bi ${t.icon}`} style={{fontSize: 15}} />
            {t.label}
          </NavLink>
        ))}
      </div>

      {children}
    </div>
  )
}

export default AffiliateShell
